module.exports = __webpack_public_path__ + "static/media/slide1.ca3577ba.jpg";